module.exports = __webpack_public_path__ + "assets/img/d13922f77efc07eea3c0fee798cec64b.svg";